import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";
import { useLocation, Link, useHistory } from "react-router-dom";
// Components
import Sidebar from "../Nav/Sidebar";
import Backdrop from "../Elements/Backdrop";
// Assets
import BurgerIcon from "../../assets/svg/BurgerIcon";
//
import Logo from "../../assets/img/nav-logo.png";
import FullButton from "../Buttons/FullButton";

export default function TopNavbar() {
  const [y, setY] = useState(window.scrollY);
  const [sidebarOpen, toggleSidebar] = useState(false);
  const location = useLocation();
  const history = useHistory();

  const openBookDemo = () => {
    history.push("/");
  };

  useEffect(() => {
    window.addEventListener("scroll", () => setY(window.scrollY));
    return () => {
      window.removeEventListener("scroll", () => setY(window.scrollY));
    };
  }, [y]);

  const isBookDemoPage = location.pathname === "/" && !(location.state && location.state.fromCtAccess);

  return (
    <>
      <Sidebar
        sidebarOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
        openScheduleModal={openBookDemo}
      />
      {sidebarOpen && <Backdrop toggleSidebar={toggleSidebar} />}
      <Wrapper
        className="flexCenter animate whiteBg"
        style={y > 100 ? { height: "60px" } : { height: "80px" }}
      >
        <NavInner className="container flexSpaceCenter">
          {location.pathname === "/" ? (
            <ScrollLink
              className="pointer flexNullCenter"
              to="home"
              smooth={true}
              onClick={() => scroll.scrollToTop()}
            >
              <NavLogo className="nav-logo" src={Logo} />
            </ScrollLink>
          ) : (
            <Link className="pointer flexNullCenter" to="/">
              <NavLogo className="nav-logo" src={Logo} />
            </Link>
          )}
          <BurderWrapper
            className="pointer"
            onClick={() => toggleSidebar(!sidebarOpen)}
          >
            <BurgerIcon />
          </BurderWrapper>
          {isBookDemoPage ? (
            <>
              <UlWrapper className="flexNullCenter"></UlWrapper>
              <UlWrapperRight className="flexNullCenter">
                <li className="semiBold font15 pointer flexCenter">
                  <a href="https://www.conversantech.com/about/" target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>
                    <ScheduleButton className="radius8">
                      About Us
                    </ScheduleButton>
                  </a>
                </li>
              </UlWrapperRight>
            </>
          ) : (
            <>
              <UlWrapper className="flexNullCenter">
                <li className="semiBold font15 pointer">
                  {location.pathname === "/ct-access" ? (
                    <ScrollLink activeClass="active" style={{ padding: "10px 15px" }} to="home" spy={true} smooth={true} offset={-80}>
                      Home
                    </ScrollLink>
                  ) : (
                    <Link className="pointer" style={{ padding: "10px 15px" }} to="/ct-access">
                      Home
                    </Link>
                  )}
                </li>
                <li className="semiBold font15 pointer">
                  {location.pathname === "/ct-access" ? (
                    <ScrollLink activeClass="active" style={{ padding: "10px 15px" }} to="projects" spy={true} smooth={true} offset={-80}>
                      Projects
                    </ScrollLink>
                  ) : (
                    <Link className="pointer" style={{ padding: "10px 15px" }} to="/ct-access">
                      Projects
                    </Link>
                  )}
                </li>
                <li className="semiBold font15 pointer">
                  {location.pathname === "/ct-access" ? (
                    <ScrollLink activeClass="active" style={{ padding: "10px 15px" }} to="services" spy={true} smooth={true} offset={-80}>
                      Services
                    </ScrollLink>
                  ) : (
                    <Link className="pointer" style={{ padding: "10px 15px" }} to="/ct-access">
                      Services
                    </Link>
                  )}
                </li>
                <li className="semiBold font15 pointer">
                  <a href="https://www.conversantech.com/about/" target="_blank" rel="noreferrer" style={{ padding: "10px 15px" }}>
                    About Us
                  </a>
                </li>
              </UlWrapper>
              <UlWrapperRight className="flexNullCenter">
                <li className="semiBold font15 pointer flexCenter">
                  <ScheduleButton onClick={openBookDemo} className="radius8">
                    Book Demo
                  </ScheduleButton>
                </li>
              </UlWrapperRight>
            </>
          )}
        </NavInner>
      </Wrapper>
    </>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  box-shadow: 0px 5px 14px -4px rgba(0, 0, 0, 0.1);
`;
const NavInner = styled.div`
  position: relative;
  height: 100%;
`;
const BurderWrapper = styled.button`
  outline: none;
  border: 0px;
  background-color: transparent;
  height: 100%;
  padding: 0 15px;
  display: none;
  @media (max-width: 760px) {
    display: block;
  }
`;
const UlWrapper = styled.ul`
  display: flex;
  @media (max-width: 760px) {
    display: none;
  }
`;
const UlWrapperRight = styled.ul`
  @media (max-width: 760px) {
    display: none;
  }
`;
const NavLogo = styled.img`
  width: 250px;
  height: 36px;
`;
const ScheduleButton = styled.button`
  background-color: #7620ff;
  color: white;
  font-size: 14px;
  border: none;
  padding: 10px 18px;
  cursor: pointer;
  margin: 10px 0px;
  width: 140px;
  font-weight: 500;

  &:hover {
    background-color: #7620ff;
    transition: all 0.3s ease-in-out;
  }
`;
